import { GenericRequestBody, GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from 'utils/general/observability/withErrorCapture'
import { ServiceUrls } from 'utils/general/serviceUrls'
import { paths } from './documentsGeneratedTypes'

interface Params {
  authorization: string
}

export class DocumentsHttpClient {
  GET
  POST
  constructor({ authorization }: Params) {
    const { GET, POST } = createClient<paths>({
      baseUrl: ServiceUrls.DOCUMENTS,
      headers: { Authorization: authorization },
    })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}

export type DocumentsRequestBody<TPath extends keyof paths, TMethod extends keyof paths[TPath]> = GenericRequestBody<
  paths,
  TPath,
  TMethod
>
export type DocumentResponse<T extends keyof paths, T2 extends keyof paths[T]> = GenericResponse<paths, T, T2>
